// Used by the apiSlice to fullfill or reject a request
export const validateStatus = (response: Response) => {
  // You can do custom validation here
  // if (body?.success === false) {
  //   return false;
  // }
  return response.status >= 200 && response.status <= 299;
};
